module.exports = __webpack_public_path__ + "img/Bootes.884bcca1.png";